;(function () {
    window.sliders = []
    window.mobileSliders = []
    // used to reinit within some sections, like product recommendations
    window.initSlider = function (el, index, closestTarget) {
        if (!el) {
            return
        }

        var closestSection = el.closest(closestTarget)
        var controls = closestSection.querySelector('.control')
        var paginationEl = closestSection.querySelector('.swiper-pagination')
        var loopControls = true

        // slider settings
        var options = {
            speed: 600,
            loop: true,
            slideToClickedSlide: false,
            centeredSlides: true,
            spaceBetween: 20,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: closestSection.querySelector('.swiper-next'),
                prevEl: closestSection.querySelector('.swiper-prev'),
            },
            pagination: {
                el: paginationEl ? paginationEl : '',
                clickable: true,
            },
            thumbs: {},
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                1500: {
                    slidesPerView: 4,
                },
            },
        }

        if (el.id === 'product-slider') {
            options.loop = false
            loopControls = false
        }

        if (el.hasAttribute('data-slidestoshow')) {
            options.breakpoints = {
                992: {},
                1199: {},
            }
            options.breakpoints[1199].slidesPerView = parseInt(
                el.getAttribute('data-slidestoshow')
            )
        }

        // For gallery sliders
        if (controls) {
            options.thumbs.swiper = new Swiper(controls, {
                speed: 600,
                loop: loopControls,
                slidesPerView: 4,
                spaceBetween: 7,
                centeredSlides: false,
                slideToClickedSlide: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                controller: {},
                autoplay: false,
                breakpoints: {
                    768: {
                        spaceBetween: 14,
                    },
                },
            })
        }

        // Collection Carousel Swiper
        if (el.classList.contains('collections-carousel-swiper')) {
            options.slidesPerView = 1
            options.spaceBetween = 10
            options.centeredSlides = false
            options.breakpoints = {
                768: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
                1199: {
                    slidesPerView:
                        parseInt(el.getAttribute('data-slidesperview')) || 3,
                    spaceBetween:
                        parseInt(el.getAttribute('data-spacebetween')) || 30,
                },
            }
        }

        if (el.classList.contains('testimonial')) {
            options.breakpoints = {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1199: {
                    slidesPerView: 3,
                },
                1500: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }
        }

        // Infinite Horizontal Scroll
        if (el.classList.contains('marquee-bar-swiper')) {
            options = {
                speed: 5000,
                loop: true,
                slidesPerView: 1.5,
                centeredSlides: false,
                spaceBetween: 10,
                freeMode: true,
                freeModeMomentum: false,
                grabCursor: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1300: {
                        slidesPerView: 4.5,
                    },
                },
            }
        }

        if (el.classList.contains('upsell-slider')) {
            options.loop = false
            el.setAttribute('id', 'upsell-slider-' + index)
        }

        if (el.getAttribute('id') && el.classList.contains('mobile')) {
            window.mobileSliders[el.getAttribute('id')] = new Swiper(
                el,
                options
            )
        } else if (el.getAttribute('id')) {
            window.sliders[el.getAttribute('id')] = new Swiper(el, options)
        } else {
            new Swiper(el, options)
        }
    }
})()
